var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay && _vm.showRule !== "render"
    ? _c(
        "preview-form-item",
        {
          attrs: {
            labelText: _vm.labelName,
            labelWidth: _vm.labelWidth,
            labelPosition: _vm.labelPosition,
            textAlign: _vm.labelTextPosition,
            formType: _vm.formType,
            variableName: _vm.model,
            rules: _vm.validatorRule,
            paddingLeft: _vm.paddingLeft
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-item_input" },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { disabled: _vm.isDisabled },
                  model: {
                    value: _vm.checkBoxModel,
                    callback: function($$v) {
                      _vm.checkBoxModel = $$v
                    },
                    expression: "checkBoxModel"
                  }
                },
                _vm._l(_vm.options, function(item, index) {
                  return _c(
                    "el-checkbox",
                    {
                      key: index,
                      style: { display: _vm.displayType },
                      attrs: { label: item.label }
                    },
                    [
                      _vm._v(
                        "\n                   " +
                          _vm._s(item.value) +
                          "\n      "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2302a2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2302a2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemCheckbox.vue
// module id = null
// module chunks = 